import { WppFileUpload, WppSpinner, WppTypography } from '@wppopen/components-library-react'
import { FileItemType, FileUploadEventDetail, uuidv4 } from '@wppopen/components-library'
import {
  WppFileUploadCustomEvent,
  Components as WppComponentTypes,
} from '@wppopen/components-library/dist/types/components'
import clsx from 'clsx'
import styles from './FileUploader.module.scss'

interface FileUploaderProps extends Partial<WppComponentTypes.WppFileUpload> {
  onFileChange: (e: WppFileUploadCustomEvent<FileUploadEventDetail>) => void
  file: FileItemType | undefined
  fileValidation: string[] | boolean
}

function FileUploader({ onFileChange, fileValidation, file, ...props }: FileUploaderProps) {
  return (
    <div className={styles.upload_section} data-testid="file-uploader">
      <WppFileUpload
        title="Upload file"
        onWppChange={onFileChange}
        data-testid="file-uploader-input"
        {...props}
        value={file ? [file] : []}
        messageType={props.message ? 'error' : props.messageType}
      />

      {file && !fileValidation && (
        <WppTypography
          tag="p"
          type="s-body"
          className={clsx(file && !fileValidation && styles.file_uploading)}
          data-testid="validating-file"
        >
          <WppSpinner size="s" />
          File being validated, please wait...
        </WppTypography>
      )}
      {file && Array.isArray(fileValidation) && (
        <div className={styles.file_validation_errors} data-testid="file-uploader-validation-errors">
          {fileValidation.map((error, index) => (
            <WppTypography
              tag="p"
              type="s-body"
              key={uuidv4()}
              className={styles.file_error}
              data-testid={`validation-error-${index}`}
            >
              {error}
            </WppTypography>
          ))}
        </div>
      )}
    </div>
  )
}

export default FileUploader
